"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof3 = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _react = _interopRequireWildcard(require("react"));

var _Title = _interopRequireDefault(require("../../Title"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../../utils");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof3(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = void 0 && (void 0).__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};
/* eslint-disable @typescript-eslint/prefer-optional-chain */

/* eslint-disable @typescript-eslint/naming-convention */

/* eslint-disable @typescript-eslint/no-unused-vars */


var BuyProduct3 = function BuyProduct3(props) {
  var flexTitle = props.flexTitle,
      desc = props.desc,
      configuration = props.configuration,
      style = props.style,
      onCallback = props.onCallback,
      layoutMode = props.layoutMode,
      buyType = props.buyType; // const [asyncompatibleArr, setAsynCompatibleArr] = useState([]);

  var layoutNum = layoutMode ? 3 : 4;
  var compatibleArr = configuration && configuration.length % layoutNum ? __spreadArrays(configuration, new Array(layoutNum - configuration.length % layoutNum).fill({
    supplement: true
  })) : configuration;
  var buyCon = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (buyCon && buyCon.current) {
      var buyConList = buyCon.current.childNodes;
      buyConList.forEach(function (item) {
        var buyConcurrent = item.getBoundingClientRect().height;
        item.childNodes[0].style.minHeight = buyConcurrent + "px"; // const childLen = item.childNodes[0].childNodes.length;
        // const descriptionTop = item.childNodes[0].childNodes[childLen - 2].getBoundingClientRect()
        //   .bottom;
        // const butTop = item.childNodes[0].childNodes[childLen - 1].getBoundingClientRect().top;
        // const dbHeight = butTop - descriptionTop + 11;
        // const descriptionHang = dbHeight / 18;
        // const dHang = Math.trunc(descriptionHang);
        // item.childNodes[0].childNodes[childLen - 3].style.cssText = `-webkit-line-clamp:${6}`;
        // item.childNodes[0].childNodes[childLen - 3].style.maxHeight = `${96}px`;
      });
    }
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-buy-now-default-container-bp-buyproduct3',
    style: (0, _typeof2["default"])(style) === 'object' ? style : {}
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'flex-buy-now-default-container__children'
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    desc: desc,
    title: flexTitle,
    buyType: buyType
  }), /*#__PURE__*/_react["default"].createElement("section", {
    className: (0, _classnames["default"])('flex-buy-now-default-container__children__container', {}),
    ref: buyCon
  }, compatibleArr && compatibleArr.map(function (item, index) {
    var _a = item || {},
        title = _a.title,
        supplement = _a.supplement,
        // duration,
    backgroundUrl = _a.backgroundUrl,
        // text_list,
    content = _a.content,
        but_txt = _a.but_txt,
        but_href = _a.but_href,
        description = _a.description,
        detail_href = _a.detail_href,
        detail_href_text = _a.detail_href_text,
        backgroundBigUrl = _a.backgroundBigUrl,
        extendProps = _a.extendProps,
        detailExtendProps = _a.detailExtendProps;

    var url = (0, _utils.fomateFileData)(backgroundBigUrl).url;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index,
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list__container', {
        'flex-buy-now-default-container__children__container__list__container--mobile': supplement
      }),
      style: layoutMode ? {
        minWidth: '30%',
        maxWidth: '33%'
      } : {}
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('flex-buy-now-default-container__children__container__list', {
        'audiovb-theme': ['audiovb'].includes(buyType)
      }),
      style: {
        backgroundImage: "url(" + url + ")"
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__head', {
        'aduiovb-head-theme': ['audiovb'].includes(buyType)
      }),
      style: backgroundUrl ? {
        background: "url(" + backgroundUrl + ")  right no-repeat",
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 32,
        height: 144,
        backgroundSize: 'auto',
        backgroundColor: '#F5FAFF',
        borderBottom: 0
      } : undefined
    }, /*#__PURE__*/_react["default"].createElement("h3", {
      className: (0, _classnames["default"])('list__title', {
        'audiovb-hover-color-title': ['audiovb'].includes(buyType)
      })
    }, ' ', title), /*#__PURE__*/_react["default"].createElement("p", {
      className: 'list__head_description',
      style: backgroundUrl ? {
        marginTop: 16
      } : {}
    }, description)), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'list__description_buynow',
      dangerouslySetInnerHTML: {
        __html: content || ''
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__default-hrefText', {
        'aduiovb-href-theme': ['audiovb'].includes(buyType)
      })
    }, detail_href && detail_href_text ? /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: detail_href
    }, detailExtendProps || {}), detail_href_text) : null), onCallback ? /*#__PURE__*/_react["default"].createElement("div", __assign({
      className: (0, _classnames["default"])('list__a', {
        'aduiovb-btn-theme': ['audiovb'].includes(buyType)
      })
    }, extendProps || {}, {
      onClick: function onClick() {
        onCallback && onCallback(item);
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: 'but_href_a'
    }, but_txt)) : /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])('list__a', {
        'aduiovb-btn-theme': ['audiovb'].includes(buyType)
      })
    }, /*#__PURE__*/_react["default"].createElement("a", __assign({
      href: but_href
    }, extendProps || {}), but_txt))));
  }))));
};

var _default = BuyProduct3;
exports["default"] = _default;